import { render, staticRenderFns } from "./ArtikelStatusDropdown.vue?vue&type=template&id=3e789fc1&"
import script from "./ArtikelStatusDropdown.vue?vue&type=script&lang=js&"
export * from "./ArtikelStatusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports